import { Component, OnInit } from '@angular/core';
import { ScholarshipService } from 'src/app/services/scholarship/scholarship.service';
import firebase from 'firebase';

@Component({
  selector: 'app-scholarship-dashboard',
  templateUrl: './scholarship-dashboard.component.html',
  styleUrls: ['./scholarship-dashboard.component.scss'],
})
export class ScholarshipDashboardComponent implements OnInit {
  constructor(private SCHOLARSHIP: ScholarshipService) {}

  submissions = [];

  options = {};

  ngOnInit(): void {
    this.SCHOLARSHIP.getCollection()
      .doc('2022 Scholarship')
      .collection('submissions')
      .get()
      .subscribe((submissions) => {
        this.submissions = [];
        submissions.forEach((entry) => {
          let data = entry.data();
          data.reqs = [];
          firebase
            .storage()
            .ref()
            .child(`scholarship2022/${data.id}`)
            .list()
            .then((files) => {
              files.items.forEach((file) => {
                file.getDownloadURL().then((url) => {
                  data.reqs.push(url);
                });
              });
            });
          data.dob = new Date(data.dob.seconds * 1000);
          this.submissions.push(data);
          console.log(data);
        });
      });
  }
}
